<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item, index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control == "Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control == "Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control == "Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control == "Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control == "Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control == "Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control == "File"' :data-val="item"></File>
			<Table v-if='item.Property.Control == "Table"' @child-event='tableOperation' :data-val='item'
				:template-data='templateData'></Table>
			<Selector v-if='item.Property.Control == "Selector"' @child-event='getSelectorVal' :data-val='item'>
			</Selector>
			<Textarea v-if='item.Property.Control == "Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control == "Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading"
			size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from '../components/Number.vue'
import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import Choose from '../components/Choose.vue';
import wx from 'weixin-js-sdk'
import stringUtils from "../assets/js/stringUtil.js";
import {
	initWxConfig
} from '../api/jssdk.js';
import {
	getTemplateInfo,
	sendMessage,
	sendMessageFirstHand
} from '@/api/approval'
import {
	getRelation
} from '@/api/employee'
import { getOptionValForDataVal, intoItemToArray } from '../utils/componentUtils'
import { LoadComponents, parseSelectorVal, getSelectorNames, difference, union, select, fillPerson, sendUrl } from "../utils/firsthandearlywarning/index"

var isSubmit = false;

var template = {
	TemplateContent: {
		Controls: []
	}
};
const sendMessagetTemplate = {
	title: null,
	url: null,
	toUser: [],
	desc: null,
	template: null,
};
export default {
	components: {
		Contact,
		Dates,
		Version,
		Money,
		Tips,
		File,
		Table,
		Digit,
		Selector,
		Textarea,
		Choose
	},
	data() {
		return {
			templateData: template,
			relationList: null,
			logInfo: null,
			templateId: "",
			spNo: null,
			flowId: null,
			formLoading: false,
			listLoading: false,
			sendMessageData: Object.assign({}, sendMessagetTemplate),
			isDisabled: false,
			tableId: [],
			nextApprover: null,
			senderPerson: null,
			// 多选框中是否包含法务起诉
			isLegal: null,
			flagSelect: ["未收金额", "对应阶段"]
		}
	},
	created() {
		initWxConfig(this);
		this.logInfo = this.getLoginUserInfo();
		this.templateId = this.$route.query.templateId;
		this.spNo = this.$route.query.spNo;
		this.flowId = this.$route.query.flowId;
		this.getTemplate();
		stringUtils.setAddIsShow(false);
	},
	methods: { //方法
		clickChoose(dataVal, name) {
			const that = this
			window.wx.invoke("selectEnterpriseContact", {
				"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
				"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
				"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
			}, function (res) {
				if (res.err_msg == "selectEnterpriseContact:ok") {
					if (typeof res.result == 'string') {
						res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
					}
					// 已选的部门列表
					const user = res.result.userList[0];
					let resultStr = '';
					dataVal.Values = [];
					// 填充被发送人或者台账负责人
					switch (name) {
						case "台账负责人":
							that.senderPerson = user.id
							break
						case "第一步审批人":
							that.nextApprover = user.id
							break
					}
					// 显示名称
					resultStr = user.name
					dataVal.Values.push([user.id, user.name]);
					dataVal.Value = resultStr;
				}
			})
		},

		getTemplate: async function () {
			this.listLoading = true;
			const that = this
			const { fullName, JobLevel, DeptName, EmpNo } = this.logInfo
			const departs = fullName.split("/");
			const ruleEmpnos = ["SC09060033", "SC07030022", "SC22001262", "SC08010029"]
			if (ruleEmpnos.indexOf(EmpNo) === -1) {
				this.Message({
					message: '没有申请权限',
					type: 'error',
					duration: 1000
				});
				this.isDisabled = true;
			}
			await getTemplateInfo(this.templateId).then(async response => {
				let controls = response.Body;
				controls.TemplateContent.Controls.forEach((item) => {
					const controlName = item.Property.Title[0].Text
					if (controlName.indexOf("达结佣条件") !== -1) {
						item.IsShow = false
					}
					switch (controlName) {
						case "申请部门":
							item.Value = DeptName
							break;
						case "申请人":
							item.Value = EmpNo
							break;
						case "营业字段发函":
							item.IsShow = false
							break;
						case "营业字段起诉":
							item.IsShow = false
							break;
						case "逐级审批使用":
							item.Values = intoItemToArray([that.$store.state.defaultMember]);
							item.Values = that.applyZhujishenpiValues(item.Values, "FirstHandEarlyWarning", { fullName: fullName });
							item.IsShow = false;
							break;
						case "第一步审批人":
							item.Property.Require = 0
							break;
						default:
							break;
					}
				});
				this.templateData = this.assignControl(controls, this.logInfo);
				this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
				this.listLoading = false;
			});
		},
		getEmployeeRelation: async function () {
			await getRelation(this.logInfo.EmpNo).then(response => {
				this.relationList = response.Body[0].Nodes;
			});
		},
		getTextVal() { },
		getSelectorVal(val, name) {
			let templateContent = this.templateData.TemplateContent;
			if (name === "追佣时间段") {
				let thisControl = templateContent.Controls.filter(e => e.Property.Title[0].Text === "追佣时间段")
				let names = []
				val.forEach(v => {
					names.push(getOptionValForDataVal(v, thisControl[0]))
				})
				templateContent.Controls.filter(e => e.Property.Title[0].Text.indexOf("达结佣条件") !== -1).forEach(item => {
					let title = item.Property.Title[0].Text
					let children = item.Config.Table.Children
					if (names.includes(title)) {
						children.forEach(child => {
							// child.Property.Require = 1
							this.childHand(child)
						})
						item.IsShow = true
					} else {
						children.forEach(child => {
							child.Property.Require = 0
						})
						item.IsShow = false
					}
				})
			}
		},
		childHand(child) {
			const text = child.Property.Title[0].Text;
			if (this.flagSelect.indexOf(text) !== -1) {
				child.Property.Require = 1
				this.defaultSelect(child)
				return
			}
			child.Property.Require = 0
			child.IsShow = false
		},
		defaultSelect(child) {
			//  Config.Selector.Options.length === 1
			if (child.Property.Control === "Selector") {
				const options = child.Config.Selector.Options;
				if (options.length > 1 || options.length === 0) {
					return
				}
				let option = options[0];
				let key = option.Key;
				child.Value = key
			}
		},
		tableOperation(val, type, datas) {
			if (type === 'compute') {
				return;
			}
			this.tableoperation(val, type, datas, this);
		},
		InitData() {
			/**
			 *  一手实体
			 * @type {{partyANature: string, commissionRecoveryPeriod: [], reachConditionList: [], remark: string, id: null, projectName: null, partyAName: null, headOfAccount: [], firstApprover: [], flowId: null, amountNotReceived: number}}
			 */
			let firstHand = {
				// 唯一标识
				Id: null,
				// 项目名称
				ProjectName: null,
				// 甲方名称
				PartyAName: null,
				// 甲方性质
				PartyANature: null,
				// 业务系统未收总金额
				AmountNotReceived: 0,
				// 台账负责人 => List<String>
				HeadOfAccount: [],
				// 第一步审批人 => List<String>
				FirstApprover: [],
				// 追佣时间段 => List<{Key,Value}>
				CommissionRecoveryPeriod: [],
				// 达结佣条件 => List<reachCondition>
				ReachConditionList: [],
				// 备注
				Remark: null,
				// 流程编号
				FlowId: null
			}

			/**
			 * 达结佣条件
			 * @type {{phaseCorrespondence: {value: string, key: string}, title: string, amountNotCollected: number}}
			 */
			let reachCondition = {
				// 达结佣条件 标题
				Title: null,
				// 未收取金额 => double
				AmountNotCollected: 0,
				// 对应阶段 => KeyValue
				//     Key =>       option-XXXX
				//     Value =>     Val
				PhaseCorrespondence: {
					Key: null,
					Value: null
				}
			}
			return { firstHand, reachCondition }
		},
		GetKeyByConfig(config, key) {
			let options = config.Selector.Options
			let optionKeyValues = options.filter(option => option.Key === key);
			if (optionKeyValues.length === 0)
				return null
			let optionValue = optionKeyValues[0].Value
			return optionValue[0].Text
		},
		SplicingData(TempleContent) {
			let { firstHand, reachCondition } = this.InitData()
			for (let control of TempleContent.Controls.filter(e => e.IsShow !== false)) {
				let tempValue = control.Value
				if (control.Property.Title[0].Text === "项目名称") {
					firstHand.ProjectName = tempValue
				}
				if (control.Property.Title[0].Text === "甲方名称") {
					firstHand.PartyAName = tempValue
				}
				if (control.Property.Title[0].Text === "甲方性质") {
					let val = this.GetKeyByConfig(control.Config, tempValue)
					firstHand.PartyANature = {
						Key: tempValue,
						Value: val
					}
				}
				if (control.Property.Title[0].Text === "业务系统未收总金额") {
					firstHand.AmountNotReceived = parseFloat(tempValue)
				}
				if (control.Property.Title[0].Text === "备注") {
					firstHand.Remark = tempValue
				}
				if (control.Property.Title[0].Text === "台账负责人") {
					firstHand.HeadOfAccount = control.Values[0]
				}
				if (control.Property.Title[0].Text === "第一步审批人") {
					if (control.Values === null || control.Values.length <= 0) {
						firstHand.FirstApprover = firstHand.HeadOfAccount
						continue
					}
					firstHand.FirstApprover = control.Values[0]
				}
				if (control.Property.Title[0].Text === "追佣时间段") {
					for (let key of control.ValuesSelect) {
						let val = this.GetKeyByConfig(control.Config, key)
						firstHand.CommissionRecoveryPeriod.push({
							Key: key,
							Value: val
						})
					}
				}
				if (control.Property.Title[0].Text.indexOf("达结佣条件") > -1) {
					let money = control.Config.Table.Children.filter(e => e.Property.Title[0].Text === "未收金额")
					// if (money.length >= 0){
					//   continue
					// }
					let mv = -1
					if (money.length > 0) {
						mv = money[0].Value
					}
					let selector = control.Config.Table.Children.filter(e => e.Property.Title[0].Text === "对应阶段")[0]
					reachCondition = JSON.parse(JSON.stringify(reachCondition))// 深拷贝
					reachCondition.Title = control.Property.Title[0].Text
					reachCondition.AmountNotCollected = Number(mv)
					reachCondition.PhaseCorrespondence.Value = this.GetKeyByConfig(selector.Config, selector.Value)
					reachCondition.PhaseCorrespondence.Key = selector.Value
					firstHand.ReachConditionList.push(reachCondition)
				}
				if (control.Property.Title[0].Text === "附件") {
					firstHand.File = control.fileNames[0]
				}
			}
			return firstHand
		},
		submit() {
			const that = this
			let templateContent = this.templateData.TemplateContent
			//数据校验
			if (!this.submitValidate(templateContent.Controls)) {
				return;
			}

			const firstHand = this.SplicingData(templateContent)
			console.log(firstHand)
			// let a = true
			// if (a){
			//   console.log("debug")
			//   return;
			// }
			that.isDisabled = true
			for (const item of templateContent.Controls.filter(e => e.IsShow === true)) {
				if (item.Property.Title[0].Text.indexOf("达结佣条件") === -1) {
					continue;
				}
				const children = item.Config.Table.Children
				for (const child of children) {
					if (child.Property.Title[0].Text !== "对应阶段") {
						continue;
					}
					if (getOptionValForDataVal(child.Value, child) !== "法务起诉") {
						continue;
					}
					this.isLegal = true
				}
			}
			var SummaryList = [];
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			var control = this.templateData.TemplateContent.Controls.filter(t => t.Property.Title[0].Text === "申请部门")[0]
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "选择所在部门：" + control.Value, "Lang": "zh_CN" });
			SummaryList.push(info);

			var control3 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text === "项目名称" })[0]
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "项目名称：" + control3.Value, "Lang": "zh_CN" });
			SummaryList.push(info);

			this.templateData.SummaryList = SummaryList
			if (isSubmit) {
				this.Message({
					message: '已提交',
					type: 'warning',
					duration: 1000
				});
				return;
			}
			isSubmit = true;
			that.listLoading = true;
			let templateDateTemp = JSON.parse(JSON.stringify(this.templateData))
			templateDateTemp.TemplateContent.Controls.filter(e => e.Property.Title[0].Text === "第一步审批人")[0].Value = [this.$store.state.defaultMember]
			that.sendMessageData.template = this.templateData;
			that.sendMessageData.title = "营业部填写";
			that.sendMessageData.firstHandDto = firstHand;

			//SC12050030
			//SC16005075
			//SC17001763
			//SC18002633
			// this.sendMessageData.toUser=["SC12050030","SC16005075","SC17001763"];
			// this.sendMessageData.toUser=["SC22001262","SC18003883"];
			let nextPerson;
			if (this.nextApprover !== null) {
				nextPerson = this.senderPerson
			}
			const url = sendUrl(this.logInfo.EmpNo, nextPerson, this.isLegal)
			this.sendMessageData.toUser = [this.senderPerson]
			//this.sendMessageData.toUser = ["SC14001718","SC22001262"]
			//this.sendMessageData.toUser = ["SC14001718"]
			this.sendMessageData.desc = "申请人：" + this.logInfo.EmpName;
			// this.sendMessageData.url=document.location.hostname+"/specialSituationReportCheck?templateId=3TmBHXKPMBbiB4AjU5APW8Wroni1dVap2bi1KXaP&empNo="+this.logInfo.EmpNo;
			// 发送到
			this.sendMessageData.url = `${document.location.hostname}/${url}`

			//提交 发信息
			sendMessageFirstHand(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData, 1, this.logInfo.EmpName).then(async response => {
				console.log(response)
				// firstHand.flowId = response.
				this.Message({
					message: '申请成功',
					type: 'success',
					duration: 3 * 1000
				});
				setTimeout(() => {
					this.$router.push("/index");
				}, 3000)
			}).catch(e => {
				that.isDisabled = false
			}).finally(() => {
				isSubmit = false;
				that.listLoading = false;
			});
		}
	}

}
</script>

<style scoped lang="less">
.pages {
	padding-bottom: 14px;
}
</style>
